/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Economics16Inputs */

const en__field__enum_primarystudyinterest_study_economics16 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Economics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economics`)
};

const de__field__enum_primarystudyinterest_study_economics16 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Economics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "Economics" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Economics16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_economics16 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Economics16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Economics16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_economics16(inputs)
	return de__field__enum_primarystudyinterest_study_economics16(inputs)
});
export { _field__enum_primarystudyinterest_study_economics16 as "_field__enum_primaryStudyInterest_STUDY_ECONOMICS" }